import Button from "./Button";
import Title from "./Title";
import Typo from "./Typo";
import VideoThumb from "./VideoThumb";

export default function ConceptCol({image, imageAlt = '', title, body, cta, onPlay}) {
    return (
        <article className="flex-1 flex flex-col max-w-[470px] h-full">
            <VideoThumb image={image}
                        imageAlt={imageAlt}
                        className="mb-10 h-40 sm:h-52 md:h-60"
                        showLabel={true}
                        onPlay={onPlay}
            />

            <div className="max-w-lg flex-1">
                <header className="mb-4">
                    <Title Elem="h3">{title}</Title>
                </header>
                <Typo dangerouslySetInnerHTML={{__html: body}}/>
            </div>

            {cta && (
                <div className="mt-12 px-2 mx-auto md:mx-0">
                    <Button {...cta}/>
                </div>
            )}
        </article>
    )
}
